
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4658|87|926|9900)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
